import moment from "moment";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { ReactComponent as CopyIcon } from "../../../../assets/images/icons/copy-outline.svg";
import { getARestaurantOrderAction } from "../../../../redux/restaurantOrder/restaurantOrderActions";

function numberWithCommas(x) {
  return x?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export default function OrderRestaurantDetail() {
  const dispatch = useDispatch();
  const { id } = useParams();
  const { order } = useSelector((state) => state.restaurantOrder);

  useEffect(() => {
    dispatch(getARestaurantOrderAction(id));
    // eslint-disable-next-line
  }, []);

  return (
    <div data-test="singleOrder-page">
      <div className="grid grid-cols-2 gap-8 pt-6">
        {/* Grid 1 */}
        <div className="h-full">
          <div className="border border-[#E4E4F3] bg-white rounded-md py-5 px-8 pb-28 h-full">
            <div className="border-b border-[#E4E4F3] py-3 flex justify-between items-center">
              <h3 className="text-lg font-medium">Order Details</h3>
            </div>

            <div className="grid grid-cols-2 gap-8 mt-6">
              <div>
                <label className="text-[#9CA3AF] text-sm mb-2">
                  Order date
                </label>
                <p className="text-[#151515] text-sm font-bold">
                  {moment(order?.created_at).format("MMM DD, YYYY")}
                </p>
              </div>
              <div>
                <label className="text-[#9CA3AF] text-sm mb-2">Order ID</label>
                <p className="text-[#151515] text-sm font-bold flex">
                  <span className="flex items-center">
                    #
                    {order?.id?.substr(0, 8) +
                      "...." +
                      order?.id?.substr(order?.id?.length - 10)}
                    <button
                      type="button"
                      onClick={() => {
                        navigator.clipboard.writeText(order?.id);
                      }}
                    >
                      <CopyIcon className="h-4 w-4 ml-1" />
                    </button>
                  </span>
                </p>
              </div>
              <div>
                <label className="text-[#9CA3AF] text-sm mb-2">
                  Order Amount
                </label>
                <p className="text-[#151515] text-sm font-bold">
                  NGN {numberWithCommas(order?.order_amount)}
                </p>
              </div>
              <div>
                <label className="text-[#9CA3AF] text-sm mb-2">
                  Delivery Fee
                </label>
                <p className="text-[#151515] text-sm font-bold">
                  NGN {numberWithCommas(order?.order_delivery_fee)}
                </p>
              </div>
              <div>
                <label className="text-[#9CA3AF] text-sm mb-2">
                  Order Discount
                </label>
                <p className="text-[#151515] text-sm font-bold">
                  NGN {numberWithCommas(order?.order_discount)}
                </p>
              </div>
              <div>
                <label className="text-[#9CA3AF] text-sm mb-2">
                  Insurance Fee
                </label>
                <p className="text-[#151515] text-sm font-bold">
                  NGN {numberWithCommas(order?.order_insurance_fee)}
                </p>
              </div>
              <div>
                <label className="text-[#9CA3AF] text-sm mb-2">
                  Service Fee
                </label>
                <p className="text-[#151515] text-sm font-bold">
                  NGN {numberWithCommas(order?.order_service_fee)}
                </p>
              </div>
              <div>
                <label className="text-[#9CA3AF] text-sm mb-2">
                  Order Status
                </label>
                <p className="text-primary text-sm font-bold">
                  {order?.status === "unshipped" ? (
                    <p className="text-primary text-sm font-bold">Unshipped</p>
                  ) : order?.status === "shipped" ? (
                    <p className="text-[#046ECF] text-sm font-bold">Shipped</p>
                  ) : order?.status === "closed" ? (
                    <p className="text-primary text-sm font-bold">Closed</p>
                  ) : order?.status === "delivered" ? (
                    <p className="text-[#00D220] text-sm font-bold">
                      Delivered
                    </p>
                  ) : (
                    ""
                  )}
                </p>
              </div>
              <div>
                <label className="text-[#9CA3AF] text-sm mb-2">
                  Total Amount
                </label>
                <p className="text-[#151515] text-sm font-bold">
                  NGN {numberWithCommas(order?.order_amount)}
                </p>
              </div>
              <div>
                <label className="text-[#9CA3AF] text-sm mb-2">
                  Payment Status
                </label>
                <p className=" text-sm font-bold">
                  {order?.order_paid ? (
                    <span className="text-[#00D220]">Paid</span>
                  ) : (
                    <span className="text-[#9CA3AF]">Unpaid</span>
                  )}
                </p>
              </div>
              {order?.order_payment_method !== null && (
                <div>
                  <label className="text-[#9CA3AF] text-sm mb-2">
                    Payment Method
                  </label>
                  <p className="text-[#1634A1] text-sm font-bold">
                    {order?.order_payment_method}
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Grid 2 */}
        <div>
          <div className="border border-[#E4E4F3] bg-white rounded-md py-5 px-8">
            <div className="border-b border-[#E4E4F3] py-3 flex justify-between items-center">
              <h3 className="text-lg font-medium">Restaurant Details</h3>
            </div>

            <div className="grid grid-cols-2 gap-8 mt-6">
              <div>
                <label className="text-[#9CA3AF] text-sm mb-2">
                  Restaurant Name
                </label>
                <p className="text-[#151515] text-sm font-bold">
                  {order?.restaurant?.restaurant_name}
                </p>
              </div>
              <div>
                <label className="text-[#9CA3AF] text-sm mb-2">
                  Restaurant Email
                </label>
                <p className="text-[#151515] text-sm font-bold">
                  {order?.restaurant?.restaurant_email}
                </p>
              </div>
              <div>
                <label className="text-[#9CA3AF] text-sm mb-2">
                  Restaurant Phone Number
                </label>
                <p className="text-[#151515] text-sm font-bold">
                  {order?.restaurant?.restaurant_phone}
                </p>
              </div>
              <div>
                <label className="text-[#9CA3AF] text-sm mb-2">
                  Completed Orders
                </label>
                <p className="text-[#151515] text-sm font-bold">{0}</p>
              </div>
            </div>
          </div>

          <div className="border border-[#E4E4F3] bg-white rounded-md py-5 px-8 mt-6">
            <div className="border-b border-[#E4E4F3] py-3 mb-4 flex justify-between items-center">
              <h3 className="text-lg font-medium">
                Product Details (Optional)
              </h3>
            </div>

            {order?.order_items?.length > 0 &&
              order?.order_items?.map((product, i) => (
                <div key={i}>
                  <div className="flex justify-between items-start mb-5">
                    <div className="flex">
                      <span className="w-6 mr-3 sm:mr-10">
                        {product.quantity}x
                      </span>
                      <div>
                        <p className="mb-1">{product?.product_name}</p>
                        {product?.product_attributes?.length > 0 &&
                          product?.product_attributes?.map((attr, i) => (
                            <p key={i} className="text-sm text-[#676565]">
                              {attr.quantity}x {attr?.title} - NGN {attr.amount}
                            </p>
                          ))}
                      </div>
                    </div>
                    <p>NGN {product?.product_amount}</p>
                  </div>
                </div>
              ))}
          </div>

          <div className="border border-[#E4E4F3] bg-white rounded-md py-5 px-8 mt-6">
            <div className="border-b border-[#E4E4F3] py-3 flex justify-between items-center">
              <h3 className="text-lg font-medium">Customer Details</h3>
            </div>

            <div className="grid grid-cols-2 gap-8 mt-6">
              <div>
                <label className="text-[#9CA3AF] text-sm mb-2">Name</label>
                <p className="text-[#151515] text-sm font-bold">
                  {order?.recipient_name}
                </p>
              </div>
              <div>
                <label className="text-[#9CA3AF] text-sm mb-2">Email</label>
                <p className="text-[#151515] text-sm  font-bold">
                  {order?.recipient_email}
                </p>
              </div>
              <div>
                <label className="text-[#9CA3AF] text-sm mb-2">
                  Phone Number
                </label>
                <p className="text-[#151515] text-sm  font-bold">
                  {order?.recipient_phone}
                </p>
              </div>
              <div>
                <label className="text-[#9CA3AF] text-sm mb-2">Address</label>
                <p className="text-[#151515] text-sm font-bold">
                  {order?.recipient_address}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
